import React from "react";
import { ThemeProvider } from "styled-components";

const theme = {
  colors: {
    link: "#593c8f",
    brand2: "#f26322",
    brand1: "#f89825",
    text_color_dark_mode: "#fffcf2",
    brand5: "#a91e5e",
    mode_light_light: "#fdfffc",
    mode_light_shade1: "#e8e8e8",
    mode_light_shade2: "#d4d4d4",
    mode_light_shade3: "#bfbfbf",
    brand3: "#e5333b",
    mode_dark_dark: "#040303",
    mode_dark_shade1: "#171111",
    mode_dark_shade2: "#2f2323",
    widget_dark_background: "#04030399",
    mode_dark_shade3: "#463434",
    brand4: "#c81d5e",
    widget_light_background: "#fdfffc99",
    get ombre() {
      return `linear-gradient(
          90deg,
          ${this.brand1} 0%,
          ${this.brand2} 18%,
          ${this.brand3} 48%,
          ${this.brand4} 89%,
          ${this.brand5} 97.37%
        )`;
    },
  },
  text: {
    PLAYFAIR_DISPLAY_BOLD_123_PX: {
      fontFamily: "PlayfairDisplay",
      fontSize: 123,
      fontWeight: "bold",
      fontStyle: "normal",
      letterSpacing: 0,
    },
    PLAYFAIR_DISPLAY_BOLD_76_PX: {
      fontFamily: "PlayfairDisplay",
      fontSize: 76,
      fontWeight: "bold",
      fontStyle: "normal",
      letterSpacing: 0,
    },
    PLAYFAIR_DISPLAY_BOLD_47_PX: {
      fontFamily: "PlayfairDisplay",
      fontSize: 47,
      fontWeight: "bold",
      fontStyle: "normal",
      letterSpacing: 0,
    },
    POPPINS_BOLD_44_PX: {
      fontFamily: "Poppins",
      fontSize: 44,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: "82px",
      letterSpacing: 0.22,
    },
    POPPINS_REGULAR_44_PX: {
      fontFamily: "Poppins",
      fontSize: 44,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: "82px",
      letterSpacing: 0.22,
    },
    POPPINS_BOLD_33_PX: {
      fontFamily: "Poppins",
      fontSize: 33,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: "61px",
      letterSpacing: 0.17,
    },
    POPPINS_REGULAR_33_PX: {
      fontFamily: "Poppins",
      fontSize: 33,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: "61px",
      letterSpacing: 0.17,
    },
    PLAYFAIR_DISPLAY_BOLD_29_PX: {
      fontFamily: "PlayfairDisplay",
      fontSize: 29,
      fontWeight: "bold",
      fontStyle: "normal",
      letterSpacing: 0,
    },
    POPPINS_BOLD_25_PX: {
      fontFamily: "Poppins",
      fontSize: 25,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: "47px",
      letterSpacing: 0.13,
    },
    POPPINS_REGULAR_25_PX: {
      fontFamily: "Poppins",
      fontSize: 25,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: "47px",
      letterSpacing: 0.13,
    },
    POPPINS_BOLD_19_PX: {
      fontFamily: "Poppins",
      fontSize: 19,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: "35px",
      letterSpacing: 0.1,
    },
    POPPINS_REGULAR_19_PX: {
      fontFamily: "Poppins",
      fontSize: 19,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: "35px",
      letterSpacing: 0.1,
    },
    PLAYFAIR_DISPLAY_BOLD_18_PX: {
      fontFamily: "PlayfairDisplay",
      fontSize: 18,
      fontWeight: "bold",
      fontStyle: "normal",
      letterSpacing: 0,
    },
    POPPINS_BOLD_14_PX: {
      fontFamily: "Poppins",
      fontSize: 14,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: "26px",
      letterSpacing: 0.07,
    },
    POPPINS_REGULAR_14_PX: {
      fontFamily: "Poppins",
      fontSize: 14,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: "26px",
      letterSpacing: 0.07,
    },
    PLAYFAIR_DISPLAY_BOLD_11_PX: {
      fontFamily: "PlayfairDisplay",
      fontSize: 11,
      fontWeight: "bold",
      fontStyle: "normal",
      letterSpacing: 0,
    },
    POPPINS_BOLD_11_PX: {
      fontFamily: "Poppins",
      fontSize: 11,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: "20px",
      letterSpacing: 0.06,
    },
    POPPINS_REGULAR_11_PX: {
      fontFamily: "Poppins",
      fontSize: 11,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: "20px",
      letterSpacing: 0.06,
    },
    POPPINS_BOLD_8_PX: {
      fontFamily: "Poppins",
      fontSize: 8,
      fontWeight: "bold",
      fontStyle: "normal",
      lineHeight: "15px",
      letterSpacing: 0.04,
    },
    POPPINS_REGULAR_8_PX: {
      fontFamily: "Poppins",
      fontSize: 8,
      fontWeight: "normal",
      fontStyle: "normal",
      lineHeight: "15px",
      letterSpacing: 0.04,
    },
  },
};

const Theme = ({ children }) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default Theme;
